var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var StyledSvg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorIconHeader;
});
export var NotificationIcon = function (_a) {
    var unread = _a.unread, empty = _a.empty;
    return (React.createElement(StyledSvg, { width: "32", height: "32", viewBox: "0 0 32 32" },
        React.createElement("g", { transform: "translate(-84 -387)" },
            React.createElement("path", { fill: "currentColor", d: "M100,388a15,15,0,1,1-15,15,15.017,15.017,0,0,1,15-15m0-1a16,16,0,1,0,16,16,16,16,0,0,0-16-16Z" }),
            React.createElement("path", { fill: empty ? 'transparent' : 'currentColor', stroke: empty ? 'currentColor' : 'transparent', d: "M105,405v-5.1a4.9,4.9,0,0,0-4.9-4.9h-.2a4.9,4.9,0,0,0-4.9,4.9V405l-2,4h5a2,2,0,0,0,4,0h5Z" }),
            unread && React.createElement("circle", { fill: "#e8595a", cx: "6", cy: "6", r: "6", transform: "translate(104 387)" }))));
};
var templateObject_1;
//# sourceMappingURL=NotificationIcon.js.map